var map = {
	"./CSAPSA-DUE.png": 72082,
	"./EU.png": 14300,
	"./EU_funded.png": 44943,
	"./FKO-Logo.png": 87546,
	"./Legebitra.webp": 82482,
	"./No-Excuse-Slovenia.png": 63557,
	"./Teilen_ICON.svg": 31182,
	"./__mitgestalten-logo.png": 98105,
	"./cc-by-sa.svg": 64512,
	"./decidim-logo-mobile.svg": 95733,
	"./decidim/brands/google.svg": 26219,
	"./focus.png": 64732,
	"./focus.svg": 40395,
	"./header_background.webp": 2411,
	"./ko.png": 85108,
	"./logo.png": 39871,
	"./logo_background.svg": 17983,
	"./mitgestalten-logo.png": 40295,
	"./myParticipationRevolution.png": 26264,
	"./myrevolution_Grafik_Desktop.png": 64813,
	"./myrevolution_Grafik_Mobile.png": 12415,
	"./shoutout_background.svg": 323,
	"./sudwind.png": 18634,
	"./vhs.png": 62837,
	"./vhs.svg": 53098,
	"./weworld.png": 59088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;